export enum AgentsQueryKeys {
  All = "allAgents",
  Agent = "agent",
}
